import BaseModal from './BaseModal.vue';

export default BaseModal;
